
import { useEffect, useState } from "react";
import { getRetestPageDetails } from "../../api/endpoints/retests/retests";

const useRetestPageDetails = (retest_id: string | undefined, refetch: boolean) => {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!retest_id) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                const response = await getRetestPageDetails(retest_id);
                setData(response.data);
            } catch (err) {
                console.error("Failed to fetch retest page details:", err);
                setError("Failed to fetch retest page details");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [retest_id, refetch]);

    return {
        retestDetails: data,
        loading,
        error
    };
};

export default useRetestPageDetails;
